import classNames from 'classnames';
import React from 'react';

import { FromAccountSelect } from '../../components/NettbankCreateTransactions/components';
import { Account } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { UseSelectedDebitAccountType } from './hooks/useSelectedDebitAccount';

type Props = {
    debitAccountState: UseSelectedDebitAccountType;
    items: Account[];
    error: string | undefined;
};

const ChoosePaymentAccountDropdown: React.FC<Props> = ({ debitAccountState, items, error }) => {
    const translated = useTranslation();
    const [debitAccount, setDebitAccount, targetFromAccount] = debitAccountState;

    return (
        <section className="multi-approval-efaktura__form-content">
            <div className="multi-approval-efaktura__intro-wrapper">
                <span id="account-selector-label" className="multi-approval-efaktura__intro-wrapper-title bold">
                    {translated.approveMultipleEFaktura.choosePaymentAccount}
                </span>
            </div>
            <FromAccountSelect
                describedBy="account-selector-label"
                className={classNames('transaction-form__from-account-selector open')}
                selected={debitAccount}
                selectedAccount={targetFromAccount}
                id="efaktura-payment-account"
                placeholder={translated.chooseAccount}
                items={items}
                onSelect={setDebitAccount}
                locked={false}
                error={
                    error
                        ? { className: 'multi-approval-efaktura__account-feedback-wrapper', message: error }
                        : undefined
                }
            />
        </section>
    );
};

export default ChoosePaymentAccountDropdown;
